import { render, staticRenderFns } from "./SidebarSection.vue?vue&type=template&id=5152d866&scoped=true&"
import script from "./SidebarSection.vue?vue&type=script&lang=js&"
export * from "./SidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSection.vue?vue&type=style&index=0&id=5152d866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152d866",
  null
  
)

export default component.exports